import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/services";

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="services-grid-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-6 mb-12 items-end">
          <div className="lg:col-span-7 reveal">
            <p className="overline">What we do</p>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-semibold tracking-tighter text-white">
              Explore our services.
              <br />
              <span className="text-[var(--rr-accent)]">Tap any job to learn more.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 reveal">
            <p className="text-[var(--rr-text-muted)] leading-relaxed">
              One trusted crew for driveways, lawns, beds, and full-property care across
              Montgomery County. Click into any service for details, then request a quote in seconds.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {SERVICES.map((s, i) => (
            <Link
              key={s.slug}
              to={`/services/${s.slug}`}
              data-testid={`service-card-${s.slug}`}
              className="reveal group relative block overflow-hidden rounded-2xl bg-[var(--rr-surface)] border border-white/5 aspect-[4/3] card-lift"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <img
                src={s.image}
                alt={s.name}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[var(--rr-bg)] via-[var(--rr-bg)]/20 to-transparent" />
              <div className="absolute inset-0 bg-[var(--rr-bg)]/0 group-hover:bg-[var(--rr-bg)]/25 transition-colors" />

              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6 flex items-end justify-between gap-3">
                <div>
                  <div className="font-display text-xl md:text-2xl font-semibold text-white tracking-tight">
                    {s.name}
                  </div>
                  <div className="text-[13px] text-white/70 mt-1">{s.tagline}</div>
                </div>
                <span className="flex-shrink-0 h-10 w-10 rounded-full bg-[var(--rr-primary)] text-white flex items-center justify-center transition-all group-hover:bg-[var(--rr-accent)] group-hover:text-[var(--rr-bg)]">
                  <ArrowUpRight className="h-4 w-4" strokeWidth={2.2} />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <p className="mt-8 text-sm text-[var(--rr-text-muted)] reveal">
          Also offering tree removal, land clearing, aeration & seeding, and mulching.{" "}
          <a href="#quote" className="text-[var(--rr-accent)] hover:underline">Ask about anything.</a>
        </p>
      </div>
    </section>
  );
}
